import { useTranslation } from 'react-i18next';
import {
  StyledCircularProgress,
  StyledContainer,
  StyledStatusMessage,
} from './styled';

const UploadMessage = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledCircularProgress size={20} />
      <StyledStatusMessage>
        {t('aiMusicGenerator:userLoopUploadModal:uploadStatus:uploading')}
      </StyledStatusMessage>
    </StyledContainer>
  );
};

export default UploadMessage;
